<template>
<v-card>
  <v-card-text
    class="pt-4"
    style="position: relative;"
  >
    <v-stepper v-model="step" style="box-shadow: none;">
        <v-stepper-items>
            <v-stepper-content step='1' class="pa-0">
                <v-container grid-list-md>
                    <v-layout row wrap justify-end>
                        <v-flex xs12>
                        <v-layout row>
                            <v-btn flat color="primary" @click="selectedUser = true">
                                Detalhes
                            </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn flat v-if="cliente.ativo" color="error" @click="desativarCliente">
                            <v-icon>cancel</v-icon>
                                Bloquear
                            </v-btn>
                            <v-btn flat v-else color="green lighten-2" @click="ativarCliente">
                            <v-icon>check_circle</v-icon>
                                Desbloquear
                            </v-btn>
                        </v-layout>
                        </v-flex>
                        <v-layout row wrap>
                            <v-flex
                            xs12
                            >
                                <v-text-field
                                    label="Nome do cliente"
                                    readonly
                                    v-if="cliente.pessoa.nome_completo"
                                    v-model="cliente.pessoa.nome_completo"
                                />
                            </v-flex>
                            <v-flex xs8>
                                <v-text-field
                                    v-model="cliente.pessoa.email"
                                    readonly
                                    label="E-mail"
                                />
                            </v-flex>
                            <v-flex
                            xs4
                            >
                                <v-text-field
                                    v-model="cliente.pessoa.data_nascimento_custom"
                                    label="Data de Nascimento"
                                    mask="##/##/####"
                                    readonly/>
                            </v-flex>
                            <v-flex xs6>
                                <v-text-field
                                    v-model="cliente.pessoa.telefone"
                                    label="Telefone"
                                    mask="(##) #####-####"
                                    readonly
                                />
                            </v-flex>
                            <v-flex
                            xs6
                            >
                                <v-text-field
                                    v-model="cliente.pessoa.cpf"
                                    label="CPF"
                                    mask="###.###.###-##"
                                    readonly/>
                            </v-flex>
                            <template v-if="cliente.pessoa.endereco">
                            <v-flex xs12 class="text-xs-center pt-2 pb-2">Endereço</v-flex>
                            <v-flex xs10>
                                <v-text-field
                                    readonly
                                    label="Logradouro"
                                    v-model="cliente.pessoa.endereco.logradouro"/>
                            </v-flex>
                            <v-flex xs2>
                                <v-text-field
                                    readonly
                                    label="Número"
                                    v-model="cliente.pessoa.endereco.numero"/>
                            </v-flex>
                            <v-flex xs6>
                                <v-text-field
                                    readonly
                                    label="Cidade"
                                    v-model="cliente.pessoa.endereco.cidade"/>
                            </v-flex>
                            <v-flex xs6>
                                <v-text-field
                                    readonly
                                    label="Bairro"
                                    v-model="cliente.pessoa.endereco.bairro"
                                />
                            </v-flex>
                            <v-flex xs4>
                                <v-text-field
                                    readonly
                                    label="Complemento"
                                    v-model="cliente.pessoa.endereco.complemento"
                                />
                            </v-flex>
                            <v-flex xs2>
                                <v-text-field
                                    readonly
                                    label="Estado"
                                    v-model="cliente.pessoa.endereco.estado"
                                />
                            </v-flex>
                            <v-flex xs3>
                                <v-text-field
                                    readonly
                                    label="País"
                                    v-model="cliente.pessoa.endereco.pais"
                                />
                            </v-flex>
                            <v-flex xs3>
                                <v-text-field
                                    readonly
                                    label="CEP"
                                    v-model="cliente.pessoa.endereco.cep"
                                />
                            </v-flex>
                                <v-select
                                xs12
                                class="text-xs-center pt-2 pb-2"
                                v-model="projetoSelecionado"
                                :items="cliente.pessoa.projetos"
                                label="Projetos"
                                hint="Selecione o projeto em caso de exclusão de conta"
                                persistent-hint
                                ></v-select>
                            </template>
                            <v-flex xs12>
                            <v-layout wrap justify-spacer-around>
                                    <v-flex xs4>
                                        <v-btn block round small color="success" @click="abrirTelaInfluenciador">
                                            <v-icon style="margin-right: 3px;">record_voice_over</v-icon>
                                            influenciador
                                        </v-btn>
                                    </v-flex>
                                    <v-flex xs4>
                                        <v-btn block round small color="info" @click="$emit('abrirTelaCartoes', cliente)">
                                            <v-icon style="margin-right: 3px;">credit_card</v-icon>
                                            Cartões
                                        </v-btn>
                                    </v-flex>
                                    <v-flex xs4>
                                        <v-btn block round small color="primary" style="color: white" @click="dialogEmail">
                                            <v-icon style="margin-right: 3px;">email</v-icon> Enviar email
                                        </v-btn>
                                    </v-flex>
                                    <v-flex xs4>
                                        <v-btn block round small color="success" dark @click="dialogHistorico = true">
                                            <v-icon style="margin-right: 3px;">account_balance_wallet</v-icon>
                                            Historico
                                        </v-btn>
                                    </v-flex>
                                    <v-flex xs4>
                                        <v-btn block round small color="secondary" @click="cardSmartlock = !cardSmartlock">
                                            <v-icon style="margin-right: 3px;">{{cardSmartlock ? 'close' : 'password'}}</v-icon>
                                            {{cardSmartlock ? '' : 'Smartlock'}}
                                        </v-btn>
                                    </v-flex>
                                    <v-flex xs4>
                                        <v-menu offset-x left transition="slide-x-reverse-transition">
                                            <template v-slot:activator="{ on }">
                                                <v-btn v-on="on" block round small color="error">
                                                    <v-icon style="margin-right: 3px;">person_remove_alt_1</v-icon>
                                                    Apagar conta
                                                </v-btn>
                                            </template>
                                            <v-card style="border-radius: 1em;">
                                                <v-card-text style="font-size: 1.2em">
                                                    Tem certeza que você desaja excluir essa conta?
                                                </v-card-text>
                                                <v-card-actions class="justify-space-around">
                                                    <v-btn
                                                        round
                                                        color="error"
                                                        @click="apagarPessoa"
                                                        block
                                                        :loading="loading"
                                                    >
                                                        Confirmar
                                                    </v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-menu>
                                    </v-flex>
                                </v-layout>
                                <v-card elevation="5" v-show="cardSmartlock">
                                    <v-card-title style="font-size: 1.3em;">Cadastrar Smartlock</v-card-title>
                                    <v-card-text>
                                        <v-text-field
                                            label="Digite o novo smartlock"
                                            v-model="smartlock"
                                            placeholder="******"
                                            :type="show ? 'text' : 'password'"
                                            :append-icon="show ? 'visibility' : 'visibility_off'"
                                            @click:append="show = !show"
                                            :min="4"
                                            autocomplete="off"
                                            single-line
                                        ></v-text-field>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-btn
                                          color="secondary"
                                          block
                                          @click="cadastrarSmartlock"
                                          :disabled="!smartlock || smartlock < 4"
                                          :loading="loading"
                                        >
                                            <v-icon class="mr-1">save</v-icon>
                                            Salvar
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-layout>
                    </v-container>
            </v-stepper-content>
            <v-stepper-content step='2' class="pa-0">
                <v-container grid-list-md>
                    <v-list>
                        <v-list-tile
                            v-for="(item, index) in lista_clientes"
                            :key="index"
                            @click="selectPerson(item)"
                        >
                             <v-list-tile-avatar>
                                <v-avatar
                                    color="grey"
                                    size="30">
                                    <img v-if="item.pessoa && item.pessoa.url_imagem_perfil" :src="item.pessoa.url_imagem_perfil" alt="trevor">
                                    <v-icon dark v-else>face</v-icon>
                                </v-avatar>
                             </v-list-tile-avatar>
                             <v-list-tile-content>
                                <v-list-tile-title>
                                    {{`${item.pessoa.nome} ${item.pessoa.sobrenome}`}}
                                </v-list-tile-title>
                                <v-list-tile-sub-title>
                                    {{item.pessoa.cpf}}
                                </v-list-tile-sub-title>
                             </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </v-container>
            </v-stepper-content>
        </v-stepper-items>
    </v-stepper>
  </v-card-text>
  <v-card-actions class="info">
      <v-spacer></v-spacer>
      <v-btn flat block dark @click.prevent="fechar">
        Fechar
      </v-btn>
      <v-spacer></v-spacer>
  </v-card-actions>
  <v-bottom-sheet persistent :value="selectedUser">
    <v-card tile v-if="selectedUser">
        <v-card-title primary-title>
            <v-avatar
                large
                left
            >
                <img :src="cliente.pessoa.url_imagem_perfil">
            </v-avatar>
            <div class="pl-3">
                <div class="assignment">{{cliente.pessoa.nome}} {{cliente.pessoa.sobrenome}}</div>
                <span class="grey--text">Cadastrado em: {{cliente.pessoa.data_cadastro.split("-").reverse().join("/")}}</span>
            </div>
        </v-card-title>
        <v-list two-line>
            <template >
                <v-list-tile
                avatar
                ripple
                >
                <v-list-tile-avatar>
                    <v-icon class="blue white--text">fingerprint</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                    <v-list-tile-title>Verificação de CPF</v-list-tile-title>
                    <v-list-tile-sub-title>CPF: {{cliente.pessoa.cpf}} - Nasc. {{cliente.pessoa.data_nascimento ? cliente.pessoa.data_nascimento.split("-").reverse().join("/") : 'Não informado!'}}</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                    <template v-if="cliente.pessoa.verificacao_cpf == 2">
                        <v-btn color="green" flat small @click="() => verify('verificacao_cpf', 'accept')">Confirmar</v-btn>
                        <v-btn color="red" flat small @click="() => reject('verificacao_cpf')">Recusar</v-btn>
                    </template>
                    <template v-else-if="cliente.pessoa.verificacao_cpf == 3">
                        <v-btn class="white--text" color="green" readonly small>Confirmado</v-btn>
                        <v-btn color="red" flat small @click="() => verify('verificacao_cpf', 'clean')">Desfazer</v-btn>
                    </template>
                    <template v-else-if="cliente.pessoa.verificacao_cpf == 1">
                        <v-btn class="white--text" color="red" @click="() => verify('verificacao_cpf', 'accept')" small>PEDENTE (IGNORAR)</v-btn>
                    </template>
                    <template v-else>
                        <v-btn class="white--text" color="red" small>Recusado</v-btn>
                        <v-btn color="green" flat small @click="() => verify('verificacao_cpf', 'clean')">Desfazer</v-btn>
                    </template>
                </v-list-tile-action>
                </v-list-tile>
            </template>
            <template >
                <v-list-tile
                avatar
                ripple
                >
                <v-list-tile-avatar>
                    <v-icon class="blue white--text">account_balance_wallet</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                    <v-list-tile-title>Verificação de documento</v-list-tile-title>
                    <v-list-tile-sub-title>
                      <v-btn :disabled="cliente.pessoa.url_cnh_front === null" class="pa-0 ma-0 mr-3" flat @click="() => abrirUrl(cliente.pessoa.url_cnh_front)">Ver frente</v-btn>
                      <v-btn :disabled="cliente.pessoa.url_cnh_back === null" class="pa-0 ma-0" flat @click="() => abrirUrl(cliente.pessoa.url_cnh_back)">Ver verso</v-btn>
                    </v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                    <template v-if="cliente.pessoa.verificacao_document == 2">
                        <v-btn color="green" flat small @click="() => verify('verificacao_document', 'accept')">Confirmar</v-btn>
                        <v-btn color="red" flat small @click="() => reject('verificacao_document')">Recusar</v-btn>
                    </template>
                    <template v-else-if="cliente.pessoa.verificacao_document == 3">
                        <v-btn class="white--text" color="green" readonly small>Confirmado</v-btn>
                        <v-btn color="red" flat small @click="() => verify('verificacao_document', 'clean')">Desfazer</v-btn>
                    </template>
                    <template v-else-if="cliente.pessoa.verificacao_document == 1">
                        <v-btn class="white--text" color="red" @click="() => verify('verificacao_document', 'accept')" small>PENDENTE (Ignorar)</v-btn>
                    </template>
                    <template v-else>
                        <v-btn class="white--text" color="red" small>Recusado</v-btn>
                        <v-btn color="green" flat small @click="() => verify('verificacao_document', 'clean')">Desfazer</v-btn>
                    </template>
                </v-list-tile-action>
                </v-list-tile>
            </template>
            <template >
                <v-list-tile
                avatar
                ripple
                >
                <v-list-tile-avatar>
                    <v-icon class="blue white--text">face</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                    <v-list-tile-title>Verificação de Self</v-list-tile-title>
                    <v-list-tile-sub-title><v-btn :disabled="cliente.pessoa.url_self === null" class="pa-0 ma-0" flat @click="() => abrirUrl(cliente.pessoa.url_self)">Ver imagem da Self</v-btn></v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                    <template v-if="cliente.pessoa.verificacao_self == 2">
                        <v-btn color="green" flat small @click="() => verify('verificacao_self', 'accept')">Confirmar</v-btn>
                        <v-btn color="red" flat small @click="() => reject('verificacao_self')">Recusar</v-btn>
                    </template>
                    <template v-else-if="cliente.pessoa.verificacao_self == 3">
                        <v-btn class="white--text" color="green" readonly small>Confirmado</v-btn>
                        <v-btn color="red" flat small @click="() => verify('verificacao_self', 'clean')">Desfazer</v-btn>
                    </template>
                    <template v-else-if="cliente.pessoa.verificacao_self == 1">
                        <v-btn class="white--text" color="red" @click="() => verify('verificacao_self', 'accept')" small>PENDENTE (Ignorar)</v-btn>
                    </template>
                    <template v-else>
                        <v-btn class="white--text" color="red" small>Recusado</v-btn>
                        <v-btn color="green" flat small @click="() => verify('verificacao_self', 'clean')">Desfazer</v-btn>
                    </template>
                </v-list-tile-action>
                </v-list-tile>
            </template>
        </v-list>
        <v-card-actions>
            <template v-if="cliente.pessoa.verificado === null">
                <v-btn class="white--text" :disabled="!userReady" color="green" @click="() => verify('verificado', 'accept')">Liberar</v-btn>
                <v-btn class="white--text" color="red" @click="() => reject('verificado')">Recusar</v-btn>
            </template>
            <template v-else>
                <v-btn class="white--text" v-if="cliente.pessoa.verificado === true" color="green" readonly small>Confirmado</v-btn>
                <v-btn class="white--text" v-else color="red" readonly small>Recusado</v-btn>
                <v-btn flat color="red" @click="() => verify('verificado', 'clean')">Desfazer</v-btn>
            </template>
            <v-spacer></v-spacer>
            <v-btn flat color="orange" @click="() => selectedUser = false">{{cliente.pessoa.verificado ? 'Fechar' : 'Cancelar'}}</v-btn>
        </v-card-actions>
    </v-card>
</v-bottom-sheet>
<v-dialog lazy :value="hasImageView" fullscreen transition="dialog-bottom-transition">
    <v-card flat v-if="imageView !== null && selectedUser == true">
        <v-card-title primary-title>
            <v-btn icon @click="imageView = null">
                <v-icon>close</v-icon>
            </v-btn>
            <v-avatar
                large
                left
            >
                <img :src="cliente.pessoa.url_imagem_perfil">
            </v-avatar>
            <div class="pl-3">
                <div class="assignment">{{cliente.pessoa.nome}} {{cliente.pessoa.sobrenome}}</div>
                <span class="grey--text">Cadastrado em: {{cliente.pessoa.data_cadastro.split("-").reverse().join("/")}}</span>
            </div>
        </v-card-title>
        <v-img
            :src="imageView"
            contain
            class="grey lighten-2"
        >
            <template v-slot:placeholder>
            <v-layout
                fill-height
                align-center
                justify-center
                ma-0
            >
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
            </v-layout>
            </template>
        </v-img>
    </v-card>
</v-dialog>
<v-dialog v-model="dialogEnviarEmail" lazy width="850" :fullscreen="$vuetify.breakpoint.xs">
    <dialog-enviar-email @fechar="dialogEnviarEmail=false" :pessoa="cliente.pessoa" @sucess="sucess" @erro="erro"/>
</v-dialog>
  <v-dialog :value="recusar" width="300" lazy>
      <v-card>
          <v-card-title>
              {{ recusar === 'verificado' ? 'Recusando cadastro' : (recusar === 'verificacao_self' ? 'Recusando Imagem de Self' : 'Recusando CPF')}}
          </v-card-title>
          <div>
              <v-divider></v-divider>
              <v-textarea
                  v-model="motivo"
                  label="Motivo da recusa"
                  counter
                  maxlength="120"
                  full-width
                  single-line
              ></v-textarea>
          </div>
          <v-card-actions>
              <v-btn class="white--text" color="green"  @click="() => verify(recusar, 'recuse')">Confirmar</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="red" flat @click="() => {
                      recusar = null;
                      motivo = ''
                  }">Cancelar</v-btn>
          </v-card-actions>
      </v-card>
  </v-dialog>
  <v-dialog v-if="dialogInflu" v-model="dialogInflu" width="600" :fullscreen="$vuetify.breakpoint.xs">
    <cad-influenciador :cliente="cliente" @fechar="dialogInflu = false"/>
  </v-dialog>
  <v-dialog v-model="dialogHistorico" v-if="dialogHistorico" width="500" scrollable>
    <historico-carteira :pessoa="cliente.pessoa" @fechar="dialogHistorico = false"/>
  </v-dialog>
</v-card>
</template>

<script>
import DialogEnviarEmail from '@/components/dialogs/DialogEnviarEmail'
import { clientesDao } from '@/api'
import CadInfluenciador from '@/components/cadastros/CadInfluenciador'
import HistoricoCarteira from '@/components/dialogs/HistoricoCarteira'

export default {
components: { DialogEnviarEmail, CadInfluenciador, HistoricoCarteira },
props: ['clienteSelecionado'],
  data () {
    return {
      step: 1,
      cardSmartlock: false,
      smartlock: '',
      show: false,
      dialogInflu: false,
      lista_clientes: [],
      imageView: null,
      cpf_cliente: null,
      dialogEnviarEmail: false,
      dialogHistorico: false,
      projetoSelecionado: null,
      cliente: {
        id_cliente: null,
        ativo: null,
        pessoa: {
          endereco: {}
        }
      },
      selectedUser: false,
      recusar: null,
      motivo: '',
      data: {}
    }
  },
  computed: {
    userReady () {
      return this.selectedUser // && this.cliente.pessoa.verificacao_cpf === 3
    },
    hasImageView () {
      return !!this.imageView
    },
    headers () {
      return this.$store.getters.headers
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  mounted () {
    if (this.clienteSelecionado) {
      this.carregarCliente()
    }
  },
  watch: {
    clienteSelecionado (val) {
      if (val) {
        this.carregarCliente()
      }
    }
  },
  methods: {
    reject (validation) {
      this.motivo = ''
      this.recusar = validation
    },
    verify (validation, option) {
      if (!this.selectedUser) {
          return false
      }
      this.$store.dispatch('verifyUser', { userid: this.cliente.pessoa.id_pessoa, validation: validation, option: option, index: this.indexUser, motivo: this.motivo })
        .then((user) => {
          this.cliente = { ...this.cliente, pessoa: user }
          this.motivo = ''
          this.recusar = null
        })
    },
    abrirTelaInfluenciador () {
        if (typeof this.clienteSelecionado === 'string') {
            this.$emit('abrirTelaInfluenciador', this.cliente)
            return
        }
        this.dialogInflu = true
        this.fechar()
    },
    abrirUrl (url) {
      this.imageView = url
    },
    fechar () {
      this.$emit('fechar')
      this.step = 1
    },
    desativarCliente () {
      this.$store.dispatch('desativarCliente', this.cliente)
      this.cliente.ativo = false
    },
    ativarCliente () {
      this.$store.dispatch('ativarCliente', this.cliente)
      this.cliente.ativo = true
    },
    async carregarCliente () {
      let tempCliente = null
      this.data = this.clienteSelecionado
      if (typeof this.clienteSelecionado === 'string') {
          this.data = { filter: 'pessoa__cpf', value: this.clienteSelecionado }
      }
      await clientesDao.detalharPorAdmin(this.data, this.headers)
      .then(response => {
      if (response.ok) {
        return response.json()
      } else {
        return response.error()
      }
      })
      .then(json => {
       tempCliente = json
      })
      .catch(error => {
      console.log(error)
      this.$emit('error', 'O usuário não foi encontrado')
      this.fechar()
      })
      if (tempCliente.length === 1) {
          tempCliente = tempCliente[0]
      } else if (tempCliente.length > 1) {
          this.step = 2
          this.lista_clientes = tempCliente
          return
      } else {
            this.$emit('error', 'O usuário não foi encontrado')
            this.fechar()
            return
      }
      if (!tempCliente.pessoa.endereco) {
        tempCliente.pessoa.endereco = {}
      }
      if (tempCliente.pessoa.data_nascimento) {
        let data = tempCliente.pessoa.data_nascimento
        let ano = data.slice(0, 4)
        let mes = data.slice(5, 7)
        let dia = data.slice(8, 10)
        tempCliente.pessoa.data_nascimento_custom = `${dia}/${mes}/${ano}`
      }
      if (tempCliente.pessoa.telefone) {
        let telefone = tempCliente.pessoa.telefone
        if (telefone.slice(0, 3) === '+55') {
        //  let telefone = telefone.slice(4, 8)
         telefone = telefone.slice(3, telefone.length)
        }
        tempCliente.pessoa.telefone = telefone
      }
      tempCliente.pessoa.nome_completo = `${tempCliente.pessoa.nome.trim()} ${tempCliente.pessoa.sobrenome.trim()}`
      this.cliente = tempCliente
    },
    selectPerson (person) {
        if (!person.pessoa.endereco) {
        person.pessoa.endereco = {}
      }
      if (person.pessoa.data_nascimento) {
        let data = person.pessoa.data_nascimento
        let ano = data.slice(0, 4)
        let mes = data.slice(5, 7)
        let dia = data.slice(8, 10)
        person.pessoa.data_nascimento_custom = `${dia}/${mes}/${ano}`
      }
      if (person.pessoa.telefone) {
        let telefone = person.pessoa.telefone
        if (telefone.slice(0, 3) === '+55') {
        //  let telefone = telefone.slice(4, 8)
         telefone = telefone.slice(3, telefone.length)
        }
        person.pessoa.telefone = telefone
      }
      person.pessoa.nome = `${person.pessoa.nome.trim()} ${person.pessoa.sobrenome.trim()}`
      this.cliente = person
      this.step = 1
      this.lista_clientes = []
    },
    dialogEmail () {
        this.dialogEnviarEmail = true
        this.$emit('fechar')
    },
    sucess (message) {
        this.$emit('sucess', message)
    },
    erro (message) {
        this.$emit('erro', message)
    },
    cadastrarSmartlock () {
        this.$store.dispatch('cadSmartLockPessoa', {
            smartlock: this.smartlock,
            id_pessoa: this.cliente.pessoa.id_pessoa
        }).then(() => {
            this.cardSmartlock = false
            this.smartlock = ''
            this.sucess('Smartlock cadastrado com sucesso')
        }).catch(() => {
            this.erro('Não foi possível cadastrar Smartlock')
        })
    },
    apagarPessoa () {
        this.$store.dispatch('apagarPessoa', {
            email: this.cliente.pessoa.email,
            app_name: this.projetoSelecionado
        }).then(() => {
            this.sucess('Cliente apagado com sucesso')
            this.carregarCliente()
        }).catch(() => {
            this.erro('Não foi possível apagar cliente')
        })
    }
}
}
</script>
